// Items adaptés au spot audiovisuel pour un médicament grand public — source :
// fiche ANSM « Supports publicitaires GP autorisés et mentions obligatoires
// associées ». Pour un complément, un cosmétique ou un DM, les bandeaux visa
// ne s'appliquent pas, mais les points « allégations » restent pertinents.
const VIDEO_CHECKLIST_ITEMS = [
  'Deux bandeaux fixes réglementaires affichés pendant TOUTE la durée du spot, chacun d\'une hauteur d\'au moins 7 % de la hauteur de l\'écran (médicament grand public).',
  'Bandeau de mise en garde : « Ceci est un médicament » (ou mention équivalente exigée pour le produit) + « Lire attentivement la notice » / « Demandez conseil à votre pharmacien », lisibles et contrastés.',
  'Numéro de visa GP délivré par l\'ANSM affiché à l\'écran, lisible — la version diffusée doit être strictement celle sur laquelle le visa a été obtenu.',
  'Mention sonore : l\'invitation à lire la notice (et, si les symptômes persistent, à consulter un médecin) est également énoncée oralement.',
  'Aucune allégation interdite : pas de garantie de guérison, pas d\'équivalence « naturel = sans danger », pas de suggestion que l\'avis du médecin ou du pharmacien est superflu (R5122-4).',
  'Aucune recommandation par un professionnel de santé, un scientifique ou une célébrité de la santé, et aucun élément s\'adressant principalement aux enfants (R5122-4).',
  'Divulgation claire du partenariat commercial si la vidéo est sponsorisée (#partenariat, #collaboration).',
];

interface Props {
  compact?: boolean;
}

/**
 * Liste informative (non interactive) des points à respecter dans la vidéo
 * elle-même. L'analyse automatique ne porte que sur la légende/les hashtags ;
 * ces points relèvent du montage et de la diffusion, donc de l'utilisateur.
 * Affichée uniquement dans le rapport d'analyse (pas sur l'écran de saisie).
 */
export default function VideoComplianceChecklist({ compact = false }: Props) {
  return (
    <div className={`rounded-xl border border-slate-200
      bg-slate-50 ${compact ? 'p-3' : 'p-4'}`}>
      <div className="flex items-center gap-2 mb-1">
        <svg className="w-4 h-4 shrink-0 text-violet-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
          <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <path d="m9 14 2 2 4-4" />
        </svg>
        <p className="text-sm font-medium text-slate-700">
          À respecter impérativement dans la vidéo
        </p>
      </div>
      <p className="text-xs text-slate-500 mb-3">
        L'analyse automatique porte sur votre légende et vos hashtags. Ces points concernent la vidéo elle-même (montage, mentions à l'écran, diffusion) — ils relèvent de votre responsabilité et n'affectent pas le score.
      </p>
      <ul className="space-y-1.5">
        {VIDEO_CHECKLIST_ITEMS.map((item, i) => (
          <li key={i} className="flex items-start gap-2.5">
            <span className="mt-0.5 shrink-0 text-violet-500">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </span>
            <span className="text-sm text-slate-600">
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
